module.exports = __webpack_public_path__ + "static/img/实验室安全考试系统.214cfd6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/实验室安全考试系统.png
// module id = vHw6
// module chunks = 13